export const CompanyPermissions = {
	dashboard: {
		id: 'company.dashboard.show',
		name: 'Dashboard',
	},
	nom035: {
		id: 'company.nom035.manager',
		name: 'NOM035',
	},
	candidates: {
		id: 'company.candidates.manager',
		name: 'Candidatos',
	},
	employees: {
		id: 'company.employees.manager',
		name: 'Gestión de colaboradores',
	},
	jobProfiles: {
		id: 'company.jobProfiles.manager',
		name: 'Perfiles de puesto',
	},
	users: {
		id: 'company.users.manager',
		name: 'Gestión de accesos',
	},
	employeeProfileEdition: {
		id: 'company.employees.profile-edition',
		name: 'Edición de perfil de colaboradores',
	},
};
